


















































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Collection, Document, Room, Participant, QueuedSong, SongListing } from "@/types";
import * as firebase from "firebase/app"; // for types
import { db } from "@/firebase";

let trackListing = [] as Array<SongListing>;

@Component
export default class SideBar extends Vue {
  @Prop({ required: true })
  room!: Document<Room>;

  @Prop({ required: true })
  me!: Document<Participant>;

  @Prop({ required: true })
  participants!: Collection<Participant>;

  @Prop({ required: true })
  songqueue!: Collection<QueuedSong>;

  searchTerm = "";

  searchResults: Array<SongListing> = [];

  @Watch("searchTerm", { immediate: true })
  async onSearchTermChange(newterm: string, oldterm: string) {
    if (newterm.length === 0) {
      this.searchResults = [];
    } else if (newterm.length >= 3) {
      // cache trackListing so it's only fetched once per client
      if (trackListing.length == 0) {
        trackListing = await fetch(this.room.data.songMenuURL).then(response => response.json());
      }

      let dataset = trackListing;

      if (newterm.indexOf(oldterm) >= 0 && this.searchResults.length > 0) {
        dataset = this.searchResults;
      }

      const searchTerms = newterm
        .toLowerCase()
        .split(/\s+/)
        .map(w => w.replace(/\W/g, ""));
      this.searchResults = dataset.filter(elm => {
        const artistTokens = elm.artist
          .toLowerCase()
          .split(/\s+/)
          .map(w => w.replace(/\W/g, ""));
        const trackTokens = elm.track
          .toLowerCase()
          .split(/\s+/)
          .map(w => w.replace(/\W/g, ""));
        return searchTerms.every(term => {
          return (
            artistTokens.findIndex(tok => tok.indexOf(term) >= 0) >= 0 ||
            trackTokens.findIndex(tok => tok.indexOf(term) >= 0) >= 0
          );
        });
      });
    }
  }

  participant(participantId: string) {
    return this.participants.data.find(elm => elm.id === participantId) || {};
  }

  addSong(song: SongListing) {
    const queuedSong = {
      listing: song,
      singer: this.me.ref.id,
      added: firebase.firestore.FieldValue.serverTimestamp(),
    };
    this.songqueue.ref.add(queuedSong);
    this.searchTerm = "";
    this.searchResults = [];
  }

  async playNext() {
    if (this.songqueue.data.length > 0) {
      await db.runTransaction(async transaction => {
        const nextSong = this.songqueue.data[0];
        await transaction.delete(this.songqueue.ref.doc(nextSong.id));
        return transaction.update(this.room.ref, { onDeck: nextSong });
      });
    }
  }

  async skipCurrent() {
    await this.room.ref.update({ currentSong: firebase.firestore.FieldValue.delete() });
  }

  removeSong(song: QueuedSong) {
    this.songqueue.ref.doc(song.id).delete();
  }

  likeSong(song: QueuedSong) {
    this.songqueue.ref.doc(song.id).update({ likes: firebase.firestore.FieldValue.increment(1) });
  }

  // Returns either the currentSong or onDeck song, we don't care which for
  // rendering
  get currentSong() {
    return this.room.data.currentSong || this.room.data.onDeck;
  }
}
